(() => {
// Runs immediately when the document is already parsed: the script loads from
// inside the main-product section, so after a theme editor re-render
// DOMContentLoaded has long since fired and would never call this again.
const h7ApplyFeaturedImages = () => {
  document.querySelectorAll('media-gallery[data-h7-featured-asset]').forEach((gallery) => {
    const wrapper = gallery.closest('.product__media-wrapper');
    const thumbnail = wrapper?.querySelector('.h7-pdp-gallery__thumb.is-active');
    const image = thumbnail?.querySelector('img');
    const src = gallery.dataset.h7FeaturedAsset;
    const mobileSrc = gallery.dataset.h7FeaturedMobileAsset;
    const thumbSrc = gallery.dataset.h7FeaturedThumbAsset;

    if (!thumbnail || !src) return;

    thumbnail.dataset.src = src;
    thumbnail.dataset.alt = gallery.dataset.h7FeaturedAlt || '';
    if (mobileSrc) {
      thumbnail.dataset.srcset = `${mobileSrc} 800w, ${src} 1600w`;
      thumbnail.dataset.sizes = '(max-width: 749px) calc(100vw - 3rem), 50vw';
    } else {
      thumbnail.removeAttribute('data-srcset');
      thumbnail.removeAttribute('data-sizes');
    }

    // The thumbnail strip renders at roughly 60px. Point its own <img> at the
    // small square asset rather than the full-size one the main slide uses,
    // otherwise the browser downloads the 1600px file to draw a thumbnail.
    if (!image) return;
    image.src = thumbSrc || src;
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.width = 240;
    image.height = 240;
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', h7ApplyFeaturedImages, { once: true });
} else {
  h7ApplyFeaturedImages();
}
})();
